"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdvancedDiscount = exports.getHighestAdvancedDiscount = exports.isValidAdvancedDiscountForItem = exports.isAdvancedDiscountApplied = void 0;
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("./computePrice");
const utils_1 = require("./utils");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
const freeDiscountedHelper_1 = require("./advanceDiscount/freeDiscountedHelper");
const common_1 = require("./advanceDiscount/common");
const qtyDiscountHelper_1 = require("./advanceDiscount/qtyDiscountHelper");
const isAdvancedDiscountApplied = (adjustments) => {
    var _a;
    return (_a = adjustments === null || adjustments === void 0 ? void 0 : adjustments.some(a => a.isDiscountRuleEnabled)) !== null && _a !== void 0 ? _a : false;
};
exports.isAdvancedDiscountApplied = isAdvancedDiscountApplied;
const isEntityRuleMatched = (discountRuleCriteria, item) => {
    var _a, _b, _c, _d;
    const { productIds, categoryIds } = discountRuleCriteria || {};
    const isProductEntityRuleMatched = productIds === null || productIds === void 0 ? void 0 : productIds.includes(item.product.id);
    const isCategoryEntityRuleMatched = (categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.includes((_b = (_a = item.product) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.id)) ||
        (categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.includes((_d = (_c = item.variant) === null || _c === void 0 ? void 0 : _c.category) === null || _d === void 0 ? void 0 : _d.id));
    return isProductEntityRuleMatched || isCategoryEntityRuleMatched;
};
/**
 *
 * @param param
 * @returns This will return only valid advanced discount after validating the
 * 1. Assigned Product/category from item
 * 2. Verify item quantity is more then what defined inside discount rule
 */
const isValidAdvancedDiscountForItem = ({ item, discount, groupByCategories, groupByProducts, }) => {
    var _a, _b;
    if (!discount)
        return false;
    const discountRuleType = discount.discountRuleType;
    const { productIds: purchasedProductIds = [], categoryIds: purchasedCategoryIds = [], qty: purchasedQty = 0, } = ((_a = discount.advanceRules) === null || _a === void 0 ? void 0 : _a.purchasedCriteria) || {};
    const { productIds: discountedProductIds = [], categoryIds: discountedCategoryIds = [], qty: discountedQty = 0, } = ((_b = discount.advanceRules) === null || _b === void 0 ? void 0 : _b.discountedCriteria) || {};
    const isPurchasedEntityEmpty = (purchasedProductIds === null || purchasedProductIds === void 0 ? void 0 : purchasedProductIds.length) || (purchasedCategoryIds === null || purchasedCategoryIds === void 0 ? void 0 : purchasedCategoryIds.length) ? false : true;
    const isDiscountedEntityEmpty = (discountedProductIds === null || discountedProductIds === void 0 ? void 0 : discountedProductIds.length) || (discountedCategoryIds === null || discountedCategoryIds === void 0 ? void 0 : discountedCategoryIds.length)
        ? false
        : true;
    if (isPurchasedEntityEmpty ||
        (discountRuleType === domain_1.DiscountRuleType.PRODUCT_CATEGORY_QTY_RULE &&
            !purchasedQty) ||
        (discountRuleType ===
            domain_1.DiscountRuleType.PRODUCT_CATEGORY_BUY_SOME_GET_SOME_RULE &&
            (isDiscountedEntityEmpty || !purchasedQty || !discountedQty))) {
        return false;
    }
    let isQtyRuleMatched = discount.discountRuleType === domain_1.DiscountRuleType.PRODUCT_CATEGORY_QTY_RULE
        ? false
        : true;
    let isBuySomeGetSomeRuleMatched = discount.discountRuleType ===
        domain_1.DiscountRuleType.PRODUCT_CATEGORY_BUY_SOME_GET_SOME_RULE
        ? false
        : true;
    const isPurchasedEntityRuleMatched = isEntityRuleMatched(discount.advanceRules.purchasedCriteria, item);
    const isDiscountedEntityRuleMatched = isEntityRuleMatched(discount.advanceRules.discountedCriteria, item);
    if (discount.discountRuleType === domain_1.DiscountRuleType.PRODUCT_CATEGORY_QTY_RULE &&
        isPurchasedEntityRuleMatched &&
        (groupByProducts || groupByCategories)) {
        const { purchasedItemsQtyCount: totalQty } = (0, common_1.getProductCategoriesCount)(discount, groupByCategories, groupByProducts);
        if (isPurchasedEntityRuleMatched && totalQty >= purchasedQty) {
            isQtyRuleMatched = true;
        }
    }
    else if (discount.discountRuleType ===
        domain_1.DiscountRuleType.PRODUCT_CATEGORY_BUY_SOME_GET_SOME_RULE &&
        isDiscountedEntityRuleMatched) {
        const details = (0, freeDiscountedHelper_1.getBuySomeGetSomeDiscountDetails)({
            discount,
            groupByCategories: (0, lodash_clonedeep_1.default)(groupByCategories),
            groupByProducts: (0, lodash_clonedeep_1.default)(groupByProducts),
        });
        isBuySomeGetSomeRuleMatched = details.isBuySomeGetSomeRuleMatched;
    }
    const isDiscountRuleMatched = (isPurchasedEntityRuleMatched || isDiscountedEntityRuleMatched) &&
        isQtyRuleMatched &&
        isBuySomeGetSomeRuleMatched;
    return isDiscountRuleMatched;
};
exports.isValidAdvancedDiscountForItem = isValidAdvancedDiscountForItem;
/**
 * @param items cart items
 * @param discount discount to apply in cart
 * @returns This will only returns the items which matched with the discount criteria
 * Ex: We've 5 items in cart for Pizza category and rule says add 10% off on Exact 4 pizza category then
 *    This function will returns only items whose total quantity is 4
 */
const getFilteredItems = (items, discount) => {
    var _a;
    const { qty: purchaseQuantity, operator: purchasedOperator } = (_a = discount.advanceRules) === null || _a === void 0 ? void 0 : _a.purchasedCriteria;
    const totalItemsQty = items.reduce((totalQty, item) => totalQty + item.quantity, 0);
    let qtyToCheck = purchaseQuantity * Math.floor(totalItemsQty / purchaseQuantity);
    const sortedItems = items.sort((a, b) => {
        if (a.unitPrice === b.unitPrice) {
            return b.quantity - a.quantity;
        }
        else
            return b.unitPrice - a.unitPrice;
    });
    if (qtyToCheck && purchasedOperator === domain_1.DiscountOperator.EXACTLY) {
        const filteredItems = [];
        sortedItems.forEach(item => {
            if (qtyToCheck > 0) {
                const itemQuantity = item.quantity >= qtyToCheck ? qtyToCheck : item.quantity;
                filteredItems.push({ ...item, quantity: itemQuantity });
                qtyToCheck -= itemQuantity;
            }
        });
        return filteredItems;
    }
    return items;
};
/**
 *
 * @param discount Discount to check
 * @returns this will returns the line total based on discount value using all the items in cart
 * Example:
 * - Get 10% off on Pizza for Exact 3 qty and we've 2 pizza items into cart so this will add both values and then
 *   find the discount values
 */
const getItemsLineTotalBasedOnDiscountRule = ({ discount, groupByCategories, groupByProducts, }) => {
    let filteredItems = [];
    const groupByEntities = getGroupEntitiesBasedOnDiscountRule({
        discount,
        groupByProducts,
        groupByCategories,
    });
    let { discountedQtyToApply } = (0, freeDiscountedHelper_1.getBuySomeGetSomeDiscountDetails)({
        discount,
        groupByCategories: (0, lodash_clonedeep_1.default)(groupByCategories),
        groupByProducts: (0, lodash_clonedeep_1.default)(groupByProducts),
    });
    const items = groupByEntities.map(entity => entity.items).flat();
    // find line totals for qty rule
    if (discount.discountRuleType === domain_1.DiscountRuleType.PRODUCT_CATEGORY_QTY_RULE ||
        discount.discountRuleType === domain_1.DiscountRuleType.PRODUCT_CATEGORY_RULE) {
        filteredItems =
            discount.discountRuleType === domain_1.DiscountRuleType.PRODUCT_CATEGORY_QTY_RULE
                ? getFilteredItems(items, discount)
                : items;
        discount.adjustmentUnit === domain_1.AdjustmentUnit.FLAT &&
            (discount.quantity = filteredItems.reduce((initQty, item) => initQty + item.quantity, 0));
        const lineTotal = filteredItems.reduce((lineTotal, item) => lineTotal + (0, computePrice_1.computeLineTotal)(item), 0);
        return { lineTotal, items };
    }
    /**
     * Find line totals for free or discounted rule
     * We're going to find line totals only for those where we're going apply discounts
     * Example: Buy 2 pizza and get 1 Drink 100% off; here we're only finding line totals for Drink not pizza
     **/
    const sortedItems = items.sort((a, b) => {
        if (a.unitPrice === b.unitPrice) {
            return b.quantity - a.quantity;
        }
        else
            return a.unitPrice - b.unitPrice;
    });
    sortedItems.forEach(item => {
        const itemQty = item.quantity > discountedQtyToApply
            ? item.quantity - discountedQtyToApply
            : discountedQtyToApply - item.quantity;
        if (itemQty >= 0) {
            filteredItems.push({ ...item, quantity: discountedQtyToApply });
            discountedQtyToApply = 0;
        }
    });
    const lineTotal = filteredItems.reduce((lineTotal, item) => lineTotal + (0, computePrice_1.computeLineTotal)(item), 0);
    return { lineTotal, items: sortedItems };
};
/*
  This will return the highest applicable discount based on item value
*/
const getHighestAdvancedDiscount = ({ item, advancedDiscounts, isManuallyTriggered, groupByCategories, groupByProducts, }) => {
    const highestDiscountValue = {
        id: '',
        amount: 0,
        totalDiscount: 0,
        adjustmentUnit: '',
    };
    let existingDiscount;
    advancedDiscounts.forEach(d => {
        const discount = (0, lodash_clonedeep_1.default)(d);
        const isValidDiscountForItem = (0, exports.isValidAdvancedDiscountForItem)({
            item,
            discount,
            groupByCategories,
            groupByProducts,
        });
        if (isValidDiscountForItem) {
            discount.adjustmentUnit === domain_1.AdjustmentUnit.FLAT &&
                (discount.quantity = item.quantity);
            /*
              If we've apply discount using function map then it should always
              overwrite other discount for that no matter what value other discount has
             */
            if (isManuallyTriggered) {
                existingDiscount = discount;
                return true;
            }
            if ((advancedDiscounts === null || advancedDiscounts === void 0 ? void 0 : advancedDiscounts.length) === 1) {
                existingDiscount = discount;
                return true;
            }
            const { lineTotal } = getItemsLineTotalBasedOnDiscountRule({
                groupByCategories,
                groupByProducts,
                discount,
            });
            // Finding the highest discount value
            const discountValue = (0, utils_1.getAdjustmentValue)(lineTotal, [discount], {
                adjustmentType: domain_1.AdjustmentType.DISCOUNT,
            });
            if ((discount.adjustmentUnit === domain_1.AdjustmentUnit.FLAT &&
                highestDiscountValue.adjustmentUnit === domain_1.AdjustmentUnit.FLAT &&
                Math.abs(discount.amount) > highestDiscountValue.amount) ||
                Math.abs(discountValue) >= highestDiscountValue.totalDiscount) {
                highestDiscountValue.id = discount.id;
                highestDiscountValue.totalDiscount = Math.abs(discountValue);
                highestDiscountValue.amount = Math.abs(discount.amount);
                highestDiscountValue.adjustmentUnit = discount.adjustmentUnit;
            }
        }
    });
    const highestDiscount = existingDiscount ||
        advancedDiscounts.find(discount => discount.id === highestDiscountValue.id);
    return (0, lodash_clonedeep_1.default)(highestDiscount);
};
exports.getHighestAdvancedDiscount = getHighestAdvancedDiscount;
/**
 *
 * @param orderItems
 * @param discounts advance discounts to add into group entities
 * @returns This will returns groupBy entities object (Entity means category or products)
 * Ex: all products from one category is groupBy into one,
 *  same way all the same products is group by into one(This will be used for modifier products)
 */
const getGroupByEntities = (orderItems) => {
    const items = (0, lodash_clonedeep_1.default)(orderItems).reverse();
    const groupByProducts = {};
    const groupByCategories = {};
    items.forEach(item => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const categoryId = ((_a = item.product.category) === null || _a === void 0 ? void 0 : _a.id) || ((_c = (_b = item.variant) === null || _b === void 0 ? void 0 : _b.category) === null || _c === void 0 ? void 0 : _c.id);
        const productId = item.product.id;
        if (categoryId) {
            groupByCategories[categoryId] = {
                ...groupByCategories[categoryId],
                items: [...((_e = (_d = groupByCategories[categoryId]) === null || _d === void 0 ? void 0 : _d.items) !== null && _e !== void 0 ? _e : []), item],
                quantityCount: (((_f = groupByCategories[categoryId]) === null || _f === void 0 ? void 0 : _f.quantityCount) || 0) + item.quantity,
            };
        }
        if (productId) {
            groupByProducts[productId] = {
                ...groupByProducts[productId],
                items: [...((_h = (_g = groupByProducts[productId]) === null || _g === void 0 ? void 0 : _g.items) !== null && _h !== void 0 ? _h : []), item],
                quantityCount: (((_j = groupByProducts[productId]) === null || _j === void 0 ? void 0 : _j.quantityCount) || 0) + item.quantity,
            };
        }
    });
    return { groupByProducts, groupByCategories };
};
/**
 *
 * @param
 * @returns This will returns the entity array based on what we defined in discount rule
 * Ex: We have define rule like: Get 2$ off for Breakfast and Coffee category
 * => In above scenarios this function will returns the array of categories object
 * [
 *  {items: [], quantityCount}, //Breakfast category
 *  {items: [], quantityCount} //Coffee category
 * ]
 */
const getGroupEntitiesBasedOnDiscountRule = ({ discount, groupByProducts, groupByCategories, discountRuleName, }) => {
    var _a;
    const ruleName = discountRuleName ||
        [
            domain_1.DiscountRuleType.PRODUCT_CATEGORY_RULE,
            domain_1.DiscountRuleType.PRODUCT_CATEGORY_QTY_RULE,
        ].includes(discount.discountRuleType)
        ? 'purchasedCriteria'
        : 'discountedCriteria';
    const { productIds, categoryIds } = ((_a = discount === null || discount === void 0 ? void 0 : discount.advanceRules) === null || _a === void 0 ? void 0 : _a[ruleName]) || {};
    const groupByEntities = [];
    if (productIds === null || productIds === void 0 ? void 0 : productIds.length) {
        const productEntities = productIds
            .map(productId => groupByProducts[productId] ? groupByProducts[productId] : undefined)
            .filter(e => e);
        groupByEntities.push(...productEntities);
    }
    if (categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.length) {
        const categoryEntities = categoryIds
            .map(categoryId => groupByCategories[categoryId]
            ? groupByCategories[categoryId]
            : undefined)
            .filter(e => e);
        groupByEntities.push(...categoryEntities);
    }
    return groupByEntities;
};
/**
 *
 * @param applicableDiscounts this will have list of discounts which can be applicable on items
 * @param groupByCategories contains items via category groupBy
 * @param groupByProducts contains items via product groupBy
 * @returns Array of items which has items and its applicable highest discount
 */
const getProcessedItemsWithHighestDiscount = ({ applicableDiscounts, groupByCategories, groupByProducts, }) => {
    const discountsToProcessed = applicableDiscounts.reduce((discountsToProcessed, discount) => {
        var _a, _b;
        const { productIds: purchasedProductIds = [], categoryIds: purchasedCategoryIds = [], } = ((_a = discount === null || discount === void 0 ? void 0 : discount.advanceRules) === null || _a === void 0 ? void 0 : _a.purchasedCriteria) || {};
        const { productIds: discountedProductIds = [], categoryIds: discountedCategoryIds = [], } = ((_b = discount === null || discount === void 0 ? void 0 : discount.advanceRules) === null || _b === void 0 ? void 0 : _b.discountedCriteria) || {};
        const { lineTotal, items } = getItemsLineTotalBasedOnDiscountRule({
            discount,
            groupByCategories,
            groupByProducts,
        });
        const discountValue = Math.abs((0, utils_1.getAdjustmentValue)(lineTotal, [discount], {
            adjustmentType: domain_1.AdjustmentType.DISCOUNT,
        }));
        /**
         * finding the same discount for multiple entity
         * 10% off on Nachos, 2$ off on nachos
         * here only highest discount should pass
         */
        const processedDiscounts = discountsToProcessed === null || discountsToProcessed === void 0 ? void 0 : discountsToProcessed.filter(processedDiscount => {
            var _a, _b, _c, _d;
            const processedItems = processedDiscount.items || [];
            const isItemsOverlap = processedItems.some(processedItem => items.some(item => {
                var _a;
                return item.id === processedItem.id ||
                    (purchasedProductIds === null || purchasedProductIds === void 0 ? void 0 : purchasedProductIds.includes(processedItem.product.id)) ||
                    (purchasedCategoryIds === null || purchasedCategoryIds === void 0 ? void 0 : purchasedCategoryIds.includes((_a = processedItem.product.category) === null || _a === void 0 ? void 0 : _a.id));
            }));
            if (isItemsOverlap)
                return true;
            const { productIds: processedProductIds = [], categoryIds: processedCategoryIds = [], } = ((_b = (_a = processedDiscount.discount) === null || _a === void 0 ? void 0 : _a.advanceRules) === null || _b === void 0 ? void 0 : _b.purchasedCriteria) || {};
            const { productIds: processedDiscountedProductIds = [], categoryIds: processedDiscountedCategoryIds = [], } = ((_d = (_c = processedDiscount.discount) === null || _c === void 0 ? void 0 : _c.advanceRules) === null || _d === void 0 ? void 0 : _d.discountedCriteria) || {};
            const isProductEntityExist = purchasedProductIds === null || purchasedProductIds === void 0 ? void 0 : purchasedProductIds.some(productId => processedProductIds === null || processedProductIds === void 0 ? void 0 : processedProductIds.includes(productId));
            const isCategoryEntityExist = purchasedCategoryIds === null || purchasedCategoryIds === void 0 ? void 0 : purchasedCategoryIds.some(categoryId => processedCategoryIds === null || processedCategoryIds === void 0 ? void 0 : processedCategoryIds.includes(categoryId));
            // find the discounts based on multiple one
            if (discount.discountRuleType ===
                domain_1.DiscountRuleType.PRODUCT_CATEGORY_BUY_SOME_GET_SOME_RULE) {
                const isDiscountedProductEntityExist = discountedProductIds === null || discountedProductIds === void 0 ? void 0 : discountedProductIds.some(productId => processedDiscountedProductIds === null || processedDiscountedProductIds === void 0 ? void 0 : processedDiscountedProductIds.includes(productId));
                const isDiscountedCategoryEntityExist = discountedCategoryIds === null || discountedCategoryIds === void 0 ? void 0 : discountedCategoryIds.some(categoryId => processedDiscountedCategoryIds === null || processedDiscountedCategoryIds === void 0 ? void 0 : processedDiscountedCategoryIds.includes(categoryId));
                return (isProductEntityExist ||
                    isCategoryEntityExist ||
                    isDiscountedProductEntityExist ||
                    isDiscountedCategoryEntityExist);
            }
            return isProductEntityExist || isCategoryEntityExist;
        });
        // If the same multiple found for the same items/category then find the highest and only apply that one
        if (processedDiscounts === null || processedDiscounts === void 0 ? void 0 : processedDiscounts.length) {
            if (processedDiscounts === null || processedDiscounts === void 0 ? void 0 : processedDiscounts.every(processedDiscount => discountValue >= processedDiscount.totalDiscount)) {
                const processedDiscountIds = processedDiscounts === null || processedDiscounts === void 0 ? void 0 : processedDiscounts.map(d => d.discount.id);
                discountsToProcessed = discountsToProcessed.filter(d => !(processedDiscountIds === null || processedDiscountIds === void 0 ? void 0 : processedDiscountIds.includes(d.discount.id)));
                return [
                    ...discountsToProcessed,
                    { discount, items, totalDiscount: discountValue },
                ];
            }
            return discountsToProcessed;
        }
        const discountToProcessed = {
            items,
            discount,
            totalDiscount: discountValue,
        };
        return [...discountsToProcessed, discountToProcessed];
    }, []);
    return discountsToProcessed;
};
/**
 *
 * @param This will set the discount for quantity based rule, only the highest discount for any items would qualified
 */
const checkAndSetAdvancedDiscounts = ({ orderItems, applicableDiscounts, adjustmentByOrderItemMap, groupByCategories, groupByProducts, isManuallyTriggered, }) => {
    var _a;
    // Find highest discount for items
    const discountsToProcessed = getProcessedItemsWithHighestDiscount({
        applicableDiscounts,
        groupByCategories,
        groupByProducts,
    });
    let applicableDiscountIds = (_a = applicableDiscounts === null || applicableDiscounts === void 0 ? void 0 : applicableDiscounts.map(d => d.id)) !== null && _a !== void 0 ? _a : [];
    applicableDiscountIds = applicableDiscountIds.filter(discountId => discountsToProcessed.some(d => { var _a; return ((_a = d.discount) === null || _a === void 0 ? void 0 : _a.id) === discountId; }));
    const itemsWithAdvanceDiscounts = orderItems.filter(item => { var _a; return (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a.find(a => a.isDiscountRuleEnabled); });
    // Remove discount on items if there is no applicable discount are present
    if (!isManuallyTriggered && (itemsWithAdvanceDiscounts === null || itemsWithAdvanceDiscounts === void 0 ? void 0 : itemsWithAdvanceDiscounts.length)) {
        itemsWithAdvanceDiscounts.forEach(item => {
            var _a;
            const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
            if (appliedDiscount &&
                appliedDiscount.isDiscountRuleEnabled &&
                !(applicableDiscounts === null || applicableDiscounts === void 0 ? void 0 : applicableDiscounts.length) &&
                !adjustmentByOrderItemMap[item.id])
                adjustmentByOrderItemMap[item.id] = { adjustment: undefined };
            else if (appliedDiscount &&
                !applicableDiscountIds.includes(appliedDiscount.id)) {
                adjustmentByOrderItemMap[item.id] = { adjustment: undefined };
            }
        });
    }
    // Remove discounts if previously applied old one which is now invalid
    if (discountsToProcessed === null || discountsToProcessed === void 0 ? void 0 : discountsToProcessed.length) {
        discountsToProcessed === null || discountsToProcessed === void 0 ? void 0 : discountsToProcessed.forEach(discountToProcessed => {
            if (!discountToProcessed.isDiscountRemove) {
                // rule to apply product/category discount
                if (discountToProcessed.discount.discountRuleType ===
                    domain_1.DiscountRuleType.PRODUCT_CATEGORY_RULE) {
                    discountToProcessed.items.forEach(item => {
                        var _a;
                        const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
                        if ((0, common_1.isAdvancedDiscountApplicable)(appliedDiscount, discountToProcessed.discount, item.id, adjustmentByOrderItemMap)) {
                            adjustmentByOrderItemMap[item.id] = {
                                adjustment: discountToProcessed.discount,
                            };
                        }
                    });
                }
                else if (discountToProcessed.discount.discountRuleType ===
                    domain_1.DiscountRuleType.PRODUCT_CATEGORY_QTY_RULE) {
                    // rule to apply product/category qty discount
                    (0, qtyDiscountHelper_1.generateQtyDiscountByOrderItemMap)((0, lodash_uniqby_1.default)(discountToProcessed.items, 'id'), discountToProcessed.discount, adjustmentByOrderItemMap, isManuallyTriggered);
                }
                else {
                    // rule to apply free or discounted discount
                    const { discountedQtyToApply } = (0, freeDiscountedHelper_1.getBuySomeGetSomeDiscountDetails)({
                        discount: discountToProcessed.discount,
                        groupByCategories: (0, lodash_clonedeep_1.default)(groupByCategories),
                        groupByProducts: (0, lodash_clonedeep_1.default)(groupByProducts),
                    });
                    (0, freeDiscountedHelper_1.generateBuySomeGetSomeAdjustmentByOrderItemMap)(discountToProcessed.discount, discountToProcessed.items, discountedQtyToApply, adjustmentByOrderItemMap);
                }
            }
        });
    }
};
/**
 *
 * @param orderItems
 * @param advancedDiscounts
 * @param isManuallyTriggered
 * @returns This function will contain the rule for advance discount
 */
const getAdjustmentByOrderItems = (orderItems, advancedDiscounts, isManuallyTriggered) => {
    const { groupByProducts, groupByCategories } = getGroupByEntities(orderItems);
    const adjustmentByOrderItemMap = {};
    if (advancedDiscounts.every(d => !d.isDiscountRuleEnabled)) {
        return adjustmentByOrderItemMap;
    }
    const applicableDiscounts = [];
    orderItems.forEach(item => {
        var _a;
        const highestDiscount = (0, exports.getHighestAdvancedDiscount)({
            item,
            advancedDiscounts,
            isManuallyTriggered,
            groupByCategories,
            groupByProducts,
        });
        if (!highestDiscount) {
            return;
        }
        else if (isManuallyTriggered &&
            (!highestDiscount || highestDiscount.id !== ((_a = advancedDiscounts === null || advancedDiscounts === void 0 ? void 0 : advancedDiscounts[0]) === null || _a === void 0 ? void 0 : _a.id))) {
            return;
        }
        !applicableDiscounts.find(d => d.id === highestDiscount.id) &&
            applicableDiscounts.push(highestDiscount);
    });
    checkAndSetAdvancedDiscounts({
        orderItems,
        applicableDiscounts,
        adjustmentByOrderItemMap,
        groupByCategories,
        groupByProducts,
        isManuallyTriggered,
    });
    return adjustmentByOrderItemMap;
};
/**
 *
 * @param orderItems where we need to find and apply the discounts
 * @param advancedDiscounts it contains discounts which we configured from Backoffice
 * @returns
 */
const getAdvancedDiscount = (orderItems, advancedDiscounts, isManuallyTriggered) => {
    let adjustmentByOrderItemMap = {};
    if (!(advancedDiscounts === null || advancedDiscounts === void 0 ? void 0 : advancedDiscounts.length) || !orderItems.length)
        return {};
    adjustmentByOrderItemMap = getAdjustmentByOrderItems(orderItems, advancedDiscounts, isManuallyTriggered);
    return adjustmentByOrderItemMap;
};
exports.getAdvancedDiscount = getAdvancedDiscount;
//# sourceMappingURL=advancedDiscountHelper.js.map